export default "__VITE_ASSET__76710ff8__"